import { AttendeeRole } from '@/constants'

const getAttendeeRoleLabel = (role: AttendeeRole): string => {
  switch (role) {
    case AttendeeRole.INVESTIGATOR:
      return 'investigator'
    case AttendeeRole.OPPOSING_COUNSEL:
      return 'opposing counsel'
    case AttendeeRole.STAFF_COUNSEL:
      return 'staff counsel'
    case AttendeeRole.WITNESS_ATTORNEY:
      return 'counsel for the witness'
    case AttendeeRole.DEFENDANT_ATTORNEY:
      return 'counsel for the defense'
    case AttendeeRole.PLAINTIFF_ATTORNEY:
      return 'counsel for the plaintiff'
    default:
      return 'counsel'
  }
}
export const identificationPrompt = (role: AttendeeRole): string => {
  const attendeeRoleLabel = getAttendeeRoleLabel(role)

  return `Could the ${attendeeRoleLabel} identify themselves and spell their last name for the record?`
}
